export const adjective = {
	singular: "client",
	plural: "clients",
};
